import { AnimatePresence, motion } from 'motion/react';
import { useFormContext } from 'react-hook-form';
import { useQuestionnaireContext } from '../../context/QuestionnaireContext';
import { isQuestion } from '../../schemas/questionnaire-schema';

export const SkipDisplay = ({ onSkip }: { onSkip: () => void }) => {
  const { state } = useQuestionnaireContext();
  const { getValues } = useFormContext();

  const { currentQuestionIndex, questions } = state;
  const question = questions[currentQuestionIndex];

  if (!question || !isQuestion(question) || question.required) {
    return null;
  }
  // Hide skip button if user has made selections on select/multiselect questions
  if (['multiselect', 'select'].includes(question.questionType)) {
    const currentValue = getValues(question.slug);

    const hasSelections = (() => {
      if (Array.isArray(currentValue)) {
        return currentValue.length > 0; // Multiselect with selections
      }
      return currentValue && currentValue !== '' && currentValue !== null && currentValue !== undefined;
    })();

    if (hasSelections) {
      return null;
    }
  }

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, x: 10 }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0, x: 10 }}
        transition={{ duration: 0.2 }}
        className="mt-6 flex items-center justify-center"
        style={{ pointerEvents: 'auto' }}
      >
        <button
          onClick={onSkip}
          className="bg-transparent border-none text-sm text-slate-500 font-normal cursor-pointer"
        >
          Skip this question
        </button>
      </motion.div>
    </AnimatePresence>
  );
};
